import Col from 'antd/es/grid/col'
import { useTranslation } from 'react-i18next'
import { UserInfo } from '@/apis/auth/auth.def'
import { IdeyaButton } from '@/common/antd/ideya-button/ideya-button'
import { useFixedBreakpoint } from '@/common/hooks/use-is-mobile'
import { selectUser } from '@/features/user/user.slice'
import { ROLE_CONTRIBUTOR } from '@/router/roles'
import { useAppSelector } from '@/redux/hooks'
import {
  canCreateIdeaPermissions,
  hasPermissionAndFirmCheck,
} from '@/utils/permissions'
import {
  SectionTitleBar,
  SectionTitleBarRef,
} from '@/pages/components/section-title-bar'
import { selectIdeaListInput } from '@/redux/slices/idea-list-input.slice'

interface IdeaListUserActionControlsProps {
  ref?: React.Ref<SectionTitleBarRef>
  isAllExpanded: boolean
  onToggleExpand: () => void
  onCreateIdea: () => void
  onClearIdeaAlerts: () => void
  onReload?: () => void
}

export const IdeaListUserActionControls = ({
  ref,
  isAllExpanded,
  onToggleExpand,
  onCreateIdea,
  onClearIdeaAlerts,
  onReload,
}: IdeaListUserActionControlsProps) => {
  const { t } = useTranslation()
  const screens = useFixedBreakpoint()
  const isMobile = !screens.md
  const ideaListInput = useAppSelector(selectIdeaListInput)
  const userInfo: UserInfo = useAppSelector(selectUser)
  const isContributor = userInfo.groupRole === ROLE_CONTRIBUTOR

  const canCreateIdea = hasPermissionAndFirmCheck(
    canCreateIdeaPermissions,
    userInfo.firmId,
    userInfo.firmRole,
    userInfo.groupRole,
    userInfo.role
  )

  return (
    <SectionTitleBar
      ref={ref}
      title={t('idea_list.idea_list')}
      reload={onReload}
      isSerperate={isMobile && ideaListInput.mobileView === 'card'}
      action={
        isMobile ? undefined : (
          <>
            <Col>
              <IdeyaButton ideyaType={'secondary'} onClick={onToggleExpand}>
                {isAllExpanded
                  ? t('idea_list.user_controls.collapse_all')
                  : t('idea_list.user_controls.expand_all')}
              </IdeyaButton>
            </Col>
            {canCreateIdea && (
              <>
                <Col>
                  <IdeyaButton
                    ideyaType={'secondary'}
                    onClick={onClearIdeaAlerts}
                  >
                    {isContributor
                      ? t('idea_list.user_controls.clear_all_alerts')
                      : t('idea_list.user_controls.clear_all_my_alerts')}
                  </IdeyaButton>
                </Col>
                <Col>
                  <IdeyaButton onClick={onCreateIdea}>
                    {t('common.create_idea')}
                  </IdeyaButton>
                </Col>
              </>
            )}
          </>
        )
      }
    />
  )
}
